import { ErrorMessages } from '../constants';
export default function responseHandler(status, response) {
  return new Promise(function (resolve) {
    if (status >= 200 && status < 300) {
      var castResp = response;
      var successResponse = {
        ok: true,
        status: status,
        response: castResp
      };
      resolve(successResponse); // Usually a 422 from Flow API with validation errors
    }

    if (response) {
      var errorResp = {
        ok: false,
        status: status,
        error: response
      };
      resolve(errorResp); // Handle case where response is an error and body is empty
    }

    resolve({
      ok: false,
      status: status,
      error: {
        messages: [ErrorMessages.NETWORK_ERROR]
      }
    });
  });
}
//# sourceMappingURL=responseHandler.js.map